import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import { PollRounded, LockRounded, ChevronRightRounded } from '@mui/icons-material';
import { useOpenSurveys } from '../hooks/use-surveys';

export function SurveysListPage(): JSX.Element {
  const { t } = useTranslation('sis');
  const navigate = useNavigate();
  const { data: surveys, isLoading } = useOpenSurveys();

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 780, mx: 'auto' }}>
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 0.5 }}>
        <PollRounded color="primary" />
        <Typography variant="h5" fontWeight={700}>
          {t('portal.surveys.title')}
        </Typography>
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t('portal.surveys.subtitle')}
      </Typography>

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress />
        </Box>
      ) : !surveys?.length ? (
        <Card variant="outlined" sx={{ borderRadius: 3 }}>
          <CardContent sx={{ textAlign: 'center', py: 6 }}>
            <PollRounded sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
            <Typography color="text.secondary">{t('portal.surveys.empty')}</Typography>
          </CardContent>
        </Card>
      ) : (
        <Stack spacing={2}>
          {surveys.map((s) => (
            <Card key={s.id} variant="outlined" sx={{ borderRadius: 3 }}>
              <CardActionArea onClick={() => navigate(`/portal-v2/surveys/${s.id}`)}>
                <CardContent>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="subtitle1" fontWeight={700}>
                        {s.title}
                      </Typography>
                      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                        <Chip
                          size="small"
                          icon={<LockRounded />}
                          label={t('portal.surveys.anonymous')}
                          color="success"
                          variant="outlined"
                        />
                        <Chip size="small" label={t('portal.surveys.minute')} variant="outlined" />
                      </Stack>
                    </Box>
                    <ChevronRightRounded color="action" />
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Stack>
      )}
    </Box>
  );
}
